// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"e9c36d16","964":"8591a31b"}[chunkId] + ".chunk.css";
};